import React from "react";
import { Status } from "src/types";
import { StatusPill } from "src/components/ui";

interface ModelHeadingSectionProps {
  identifierHeader: string;
  status?: Status;
  statusLinkPath?: string;
}

const ModelHeadingSection: React.FC<ModelHeadingSectionProps> = ({ identifierHeader, status, statusLinkPath }) => (
  <section className="flex items-center gap-4 whitespace-nowrap">
    <h1 className="text-2xl font-bold text-secondary-900">{identifierHeader}</h1>
    {status && <StatusPill status={status} linkPath={statusLinkPath} />}
  </section>
);

export { ModelHeadingSection };
